import { cn } from "../lib";
import { SQ_GREEN_LINEAR_GRADIENT_CLASS } from "./sq-color-runtime-exports";
/**
 * Shared visuals for circular checkbox / radio controls (EXP gradient, recessed well,
 * logo-strip-aligned outer hairline). Consumed by {@link Checkbox}, {@link RadioGroupItem},
 * and menu radio indicators.
 */

/** 22px outer shell: border, padding ring — pair with {@link CIRCULAR_FIELD_WELL_CLASS}. */
export const CIRCULAR_FIELD_OUTER_SHELL_CLASS =
	"flex size-[22px] shrink-0 items-center justify-center rounded-full border border-black/15 bg-white p-[3px] ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-white/12 dark:bg-neutral-950";

/** Inner recessed disc inside the outer shell. */
export const CIRCULAR_FIELD_WELL_CLASS =
	"relative flex size-full items-center justify-center rounded-full bg-neutral-50 shadow-[inset_0_2px_5px_rgba(0,0,0,0.12)] dark:bg-neutral-900 dark:shadow-[inset_0_2px_8px_rgba(0,0,0,0.55)]";

/** Selected-state gradient disk (14px) — completion-overlay palette. */
export const CIRCULAR_FIELD_EXP_DISK_CLASS = cn(
	"flex size-[14px] items-center justify-center rounded-full text-white",
	SQ_GREEN_LINEAR_GRADIENT_CLASS,
);

/** Compact radio glyph for dropdown/context rows (selected state only). */
export const MENU_RADIO_OUTER_CLASS =
	"flex size-[18px] shrink-0 items-center justify-center rounded-full border border-black/15 bg-white p-[2px] dark:border-white/12 dark:bg-neutral-950";

export const MENU_RADIO_WELL_CLASS =
	"flex size-full items-center justify-center rounded-full bg-neutral-50 shadow-[inset_0_1px_3px_rgba(0,0,0,0.1)] dark:bg-neutral-900 dark:shadow-[inset_0_1px_5px_rgba(0,0,0,0.55)]";

export const MENU_RADIO_EXP_DISK_CLASS = cn(
	"flex size-[11px] items-center justify-center rounded-full text-white",
	SQ_GREEN_LINEAR_GRADIENT_CLASS,
);
